module.exports = __webpack_public_path__ + "img/vt-nav-img.92bd379d.svg";